import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/maxcredible.webp';
import screenshot_target from '../../../images/letterfunnel/frisovandebeeten.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Friso van de Beeten"
      firstname="Friso"
      companyname="MaxCredible"
      competition="Payt en Onguard"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/frisovandebeeten.js